import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import axiosInstance from 'services/APIService';

const useAuthenticationInterceptor = (): void => {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const authInterceptor = axiosInstance.interceptors.request.use(
      async config => {
        // auth0-spa-js handles token refreshing and fetching automagically.
        const token = await getAccessTokenSilently();

        // @ts-ignore
        config.headers.common.Authorization = `Bearer ${token}`;

        return config;
      },
      error => {
        return Promise.reject(error);
      },
    );

    return () => {
      axiosInstance.interceptors.request.eject(authInterceptor);
    };
  }, [getAccessTokenSilently]);
};

export default useAuthenticationInterceptor;
